import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './BelievePage.css';

// Replace with your actual flyer image import
import believeFlyer from '../Assets/storyfest/believe.png'; 

const BelievePage = () => {
  const navigate = useNavigate();

  return (
    <div className="storyfest-believe-page">
      
      {/* Background Texture/Pattern */}
      <div className="storyfest-believe-bg-pattern"></div>
      
      {/* Decorative Glows */}
      <div className="storyfest-glow storyfest-glow-gold"></div>
      <div className="storyfest-glow storyfest-glow-blue"></div>

      {/* Navigation / Return Home */}
      <div className="storyfest-believe-nav">
        <Link to="/storyfest" className="storyfest-back-link">← Return to StoryFest</Link>
      </div>

      {/* Main Content Container */}
      <div className="storyfest-believe-container">
        
        <div className="storyfest-believe-grid">
          
          {/* LEFT SIDE: Editorial Text & CTA */}
          <div className="storyfest-believe-text-content">
            
            <div className="storyfest-believe-badge">
              <span className="storyfest-pulse-dot"></span>
              A Christmas Musical
            </div>

            <h1 className="storyfest-believe-title">
              Believe in<br />
              <span className="storyfest-text-gold-italic">something</span><br />
              extraordinary.
            </h1>
            
            <p className="storyfest-believe-description">
              This Christmas, experience an original theatrical journey filled 
              with soul-stirring music, captivating storytelling, and the 
              wonder and magic of believing.
            </p>

            {/* 👇 NEW: The Story Synopsis Section */}
            <div className="storyfest-believe-synopsis">
              <h3 className="storyfest-believe-synopsis-title">The Story</h3>
              <p className="storyfest-believe-synopsis-text">
                Set in Accra, Ghana, <em>Believe</em> is a poignant Christmas musical that follows 
                Jeffrey Winters, a grieving eleven-year-old orphan who, facing a lonely holiday, 
                renounces his belief in magic and wonder. His heartbroken declaration inadvertently 
                transports him to the magical "Realm of Wonder," where his lost faith empowers 
                "The System"—a calculating corporate entity that seizes control of the realm and 
                transforms Accra into a sterile, emotionless dystopia in exchange for erasing 
                Jeffrey's pain.
              </p>
              <p className="storyfest-believe-synopsis-text">
                As a rogue squad of elves scrambles to reignite the city's joy through small, 
                chaotic acts of kindness, Jeffrey realizes that surrendering his grief also means 
                losing the precious memory of his mother's voice. Ultimately, with the support of 
                a makeshift community of teachers, neighbors, and his estranged uncle, Jeffrey 
                bravely chooses to embrace his pain and love—sparking a global cascade of belief 
                that defeats The System and restores vibrant hope to the world.
              </p>
            </div>

            {/* Main CTA Button - Navigates to Days Selection */}
            <button 
              onClick={() => navigate('/believe-days')} 
              className="storyfest-btn-believe storyfest-btn-gold"
            >
              Get Believe Tickets
              <span className="storyfest-arrow">↗</span>
            </button>

          </div>

          {/* RIGHT SIDE: Flyer Display */}
          <div className="storyfest-believe-flyer-content">
            <div className="storyfest-believe-flyer-wrapper">
              <img 
                src={believeFlyer} 
                alt="Believe Christmas Musical Flyer" 
                className="storyfest-believe-flyer-img" 
              />
            </div>
            
            {/* Secondary CTA below flyer - Navigates to Days Selection */}
            <button 
              onClick={() => navigate('/believe-days')} 
              className="storyfest-btn-believe storyfest-btn-outline storyfest-btn-below-flyer"
            >
              Get Tickets Now
              <span className="storyfest-arrow">→</span>
            </button>
          </div>

        </div>

      </div>

      {/* Footer Strip */}
      <div className="storyfest-believe-footer">
        <p>© 2026 StoryFest. An Ample House production.</p>
      </div>

    </div>
  );
};

export default BelievePage;